<template>
    <ExtendedLayout
        :user="user"
        currentTab="permissions"
    >

        <InertiaLink :href="$route('admin::users.permissions.create', { user: user.id })" class="inline-block bg-white shadow rounded-lg py-4 px-8 hover:bg-gray-100 transition-all font-bold">
            {{ __('admin::general.create_model', {'model': __('admin::permissions.permission').toLowerCase() }) }}
        </InertiaLink>

        <Table
            :headings="[
                __('admin::labels.service'),
                __('admin::labels.role'),
            ]"
            :paginator="paginator"
            :withFilters="false"
        >

            <template #results>
                <tr v-for="permission in paginator.data" :key="permission.id">
                    <td>{{ serviceOptions[permission.service] }}</td>
                    <td>{{ serviceRoleOptions[permission.role] }}</td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::users.permissions.edit', { user: user.id, permission: permission.id })"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::users.permissions.destroy', { user: user.id, permission: permission.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::permissions.permission') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';

export default {
    components: {
        ExtendedLayout,
    },
    props: {
        errors: Object,
        user: Object,
        paginator: Object,
        serviceOptions: Object,
        serviceRoleOptions: Object,
    },
    data() {
        return {
            deleting: null,
        }
    },
}
</script>
